@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.rides
import com.narbase.letsgo.dto.core.KmmLong

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.rides.NewRideRequestDto
import com.narbase.letsgo.web.dto.rides.OpenRideRequestDto


object RequestOpenRideEndpoint : EndPoint<RequestOpenRideEndpoint.Request, RequestOpenRideEndpoint.Response>() {
    class Request(
        val request: OpenRideRequestDto,
        val fcmToken: String? = null,
        val isAndroid: Boolean? = null
    )

    class Response(
        val requestId: KmmLong,
        val bookingKey: String,
        val passengerRideDto: PassengerRideDto
    )
}